export function generateYearList(startYear) {
    const currentYear = new Date().getFullYear(); // Obtém o ano atual
    const years = [];

    for (let year = startYear; year <= currentYear; year++) {
        years.push({ name: year.toString(), value: year });
    }

    return years;
}